import { useMutation, useQuery, useQueryClient, useQueries } from '@tanstack/react-query';

import {
  createMCPServer,
  createMCPServerJourney,
  deleteMCPServerJourney,
  getMCPServers,
  getMCPServerJourneys,
  updateMCPServerJourney,
  deleteMCPServer,
  updateMCPServer,
} from './requests';

export const useMCPServers = () => {
  return useQuery({
    queryKey: ['mcp-servers'],
    queryFn: getMCPServers,
  });
};

export const useCreateMCPServer = () => {
  return useMutation({
    mutationFn: createMCPServer,
  });
};

export const useMCPServerJourneys = (serverId: string) => {
  return useQuery({
    queryKey: ['mcp-server-journeys', serverId],
    queryFn: () => getMCPServerJourneys(serverId),
  });
};

export const useMCPServerJourneyCounts = (serverIds: string[]) => {
  return useQueries({
    queries: serverIds.map((serverId) => ({
      queryKey: ['mcp-server-journeys', serverId],
      queryFn: () => getMCPServerJourneys(serverId),
    })),
  });
};

export const useCreateMCPServerJourney = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createMCPServerJourney,
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['mcp-server-journeys', data.server] });
    },
  });
};

export const useUpdateMCPServerJourney = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateMCPServerJourney,
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['mcp-server-journeys', data.server] });
    },
  });
};

export const useDeleteMCPServerJourney = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ serverId, id }: { serverId: string; id: number }) =>
      deleteMCPServerJourney(serverId, id),
    onSuccess: (_, { serverId }) => {
      queryClient.invalidateQueries({ queryKey: ['mcp-server-journeys', serverId] });
    },
  });
};

export const useDeleteMCPServer = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteMCPServer,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['mcp-servers'] });
    },
  });
};

export const useUpdateMCPServer = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateMCPServer,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['mcp-servers'] });
    },
  });
};
